import Skeleton from '@components/skeleton';

const SKELETON_ITEMS = 6;

export default function CountryPickerSkeleton(): React.JSX.Element {
  return (
    <div className="country-picker" aria-hidden="true">
      {Array.from({ length: SKELETON_ITEMS }, (_, i) => (
        <div
          key={`skeleton-country-${i}`}
          className="country-picker__item country-picker__item--skeleton"
        >
          <Skeleton width="20px" height="15px" borderRadius="3px" />
          <Skeleton width={`${50 + (i % 3) * 20}px`} height="13px" borderRadius="4px" />
        </div>
      ))}
    </div>
  );
}
